export const environment = {
  production: false,
   api: 'https://api-service.vms-systems.com/api' ,
   apiKey:'ca03na188ame03u1d78620de67282882a84'
};
